import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import cx from 'classnames'

import { LOCALE_PREFIX } from '../../constants'

import './style.scss'

@injectIntl
export default class Terminology extends Component {
    static propTypes = {
        customData: PropTypes.object,
        saveCustomData: PropTypes.func,
        intl: PropTypes.object,
    }

    constructor() {
        super()

        this.state = { open: false }
    }

    toggleTerminologyTexts = () => {
        const { saveCustomData, customData } = this.props

        this.setState((prevState) => {
            saveCustomData({ ...customData, isTerminologyOpen: !prevState.open })

            return { open: !prevState.open }
        })
    }

    render() {
        const { intl } = this.props
        const { open } = this.state

        return (
            <div className={'alza-terminology-wrap'}>
                <div onClick={this.toggleTerminologyTexts} className={'terminology-toggle'}>
                    <div className={cx('terminology-toggle-icon', open ? 'expand' : 'collapse')} />
                    <div className={'terminology-toggle-button'}>
                        {intl.formatMessage(
                            { id: `${LOCALE_PREFIX}.terminologyToggleText` },
                            {
                                strong: (chunks) => <strong>{chunks}</strong>,
                                br: <br />,
                                acz: (chunks) => (
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="link"
                                        href="https://www.dnb.com/cs-cz/privacy/dokumenty"
                                    >
                                        {chunks}
                                    </a>
                                ),
                                ask: (chunks) => (
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="link"
                                        href="https://www.dnb.com/sk-sk/privacy/dokumenty"
                                    >
                                        {chunks}
                                    </a>
                                ),
                            }
                        )}
                    </div>
                </div>
                {open && (
                    <div className={'terminology-texts'}>
                        {intl.formatMessage(
                            { id: `${LOCALE_PREFIX}.terminologyScoringText` },
                            {
                                strong: (chunks) => <strong>{chunks}</strong>,
                                br: <br />,
                                acz: (chunks) => (
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="link"
                                        href="https://www.dnb.com/cs-cz/privacy/dokumenty"
                                    >
                                        {chunks}
                                    </a>
                                ),
                                ask: (chunks) => (
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="link"
                                        href="https://www.dnb.com/sk-sk/privacy/dokumenty"
                                    >
                                        {chunks}
                                    </a>
                                ),
                            }
                        )}
                    </div>
                )}
                {open && (
                    <div className={'terminology-texts'}>
                        {intl.formatMessage(
                            { id: `${LOCALE_PREFIX}.terminologyKreditText` },
                            {
                                strong: (chunks) => <strong>{chunks}</strong>,
                                br: <br />,
                                acz: (chunks) => (
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="link"
                                        href="https://www.dnb.com/cs-cz/privacy/dokumenty"
                                    >
                                        {chunks}
                                    </a>
                                ),
                                ask: (chunks) => (
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="link"
                                        href="https://www.dnb.com/sk-sk/privacy/dokumenty"
                                    >
                                        {chunks}
                                    </a>
                                ),
                            }
                        )}
                    </div>
                )}
                {open && (
                    <div className={'terminology-texts'}>
                        {intl.formatMessage(
                            { id: `${LOCALE_PREFIX}.terminologyTransactionText` },
                            {
                                strong: (chunks) => <strong>{chunks}</strong>,
                                br: <br />,
                                acz: (chunks) => (
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="link"
                                        href="https://www.dnb.com/cs-cz/privacy/dokumenty"
                                    >
                                        {chunks}
                                    </a>
                                ),
                                ask: (chunks) => (
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="link"
                                        href="https://www.dnb.com/sk-sk/privacy/dokumenty"
                                    >
                                        {chunks}
                                    </a>
                                ),
                            }
                        )}
                    </div>
                )}
                {open && (
                    <div className={'terminology-texts'}>
                        {intl.formatMessage(
                            { id: `${LOCALE_PREFIX}.terminologyLimitsText` },
                            {
                                strong: (chunks) => <strong>{chunks}</strong>,
                                br: <br />,
                                b: (chunks) => <b>{chunks}</b>,
                                acz: (chunks) => (
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="link"
                                        href="https://www.dnb.com/cs-cz/privacy/dokumenty"
                                    >
                                        {chunks}
                                    </a>
                                ),
                                ask: (chunks) => (
                                    <a
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="link"
                                        href="https://www.dnb.com/sk-sk/privacy/dokumenty"
                                    >
                                        {chunks}
                                    </a>
                                ),
                            }
                        )}
                    </div>
                )}
            </div>
        )
    }
}
